import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
    logo: {
        width: 40,
        borderRadius: 20,
        backgroundColor: '#fff',
        padding: 4
    }
}))

const Logo = (props) => {
    const classes = useStyles()

    return (
        <img
            alt="Logo"
            className={classes.logo}
            src="/static/logo.png"
            {...props}
        />
    )
}

export default Logo
